(() => {
  angular
    .module('gm.common.services')
    .factory('btgFeedback', btgFeedbackFactory);

  function btgFeedbackFactory(
    gmApi
  ) {
    'ngInject';

    return {
      send(message) {
        const data = {
          message
        };

        return gmApi.post('users/feedback', data, { auth: true });
      }
    };
  }
})();
